import { useTheme } from "@/shared/useTheme";
import { IC_CLASS, RailButton } from "./RailButton";

/** Luna di giorno, sole di notte: l'icona dice dove porta il tasto. */
export function IconaTema({ scuro, className = IC_CLASS }: { scuro: boolean; className?: string }) {
  return scuro ? (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  ) : (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  );
}

/** Tasto del tema nella barra a sinistra, sopra «Esci». */
export function RailTemaButton({ compatto = false }: { compatto?: boolean }) {
  const { theme, toggle } = useTheme();
  const scuro = theme === "dark";
  return (
    <RailButton
      ariaLabel={scuro ? "Passa al tema chiaro" : "Passa al tema scuro"}
      label={scuro ? "Chiaro" : "Scuro"}
      onClick={toggle}
      icon={<IconaTema scuro={scuro} />}
      compatto={compatto}
    />
  );
}
